<template>

    <a
      class="list-group-item list-group-item-action"
      :href="approval.url">
      <small>{{ $t('Requisition') }}</small>
      <h5 class="mb-1">{{ approval.title }}</h5>
    </a>

</template>

<script>
export default {
  name: 'ApprovalListItem',
  components: {
  },
  props: {
    approval: {
      type: Object
    }
  },
  data () {
    return {
      loading: false
    }
  },
  computed: {
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Approval/ApprovalListItem.vue